import React from 'react';
import { Attachments } from 'components';
import { useParams } from 'react-router-dom';
import { PERMISSIONS } from 'constants/permissions';
import { useAccessControl } from 'components/common/accessControl/useAccessControl';

export const BrandAttachments = React.memo(() => {
  const { id } = useParams() as { id: string };
  const { hasAccess } = useAccessControl();
  return (
    <Attachments
      entityId={id}
      hasAccessToWrite={hasAccess(PERMISSIONS.brands.attachment.write)}
      hasAccessToDelete={hasAccess(PERMISSIONS.brands.attachment.delete)}
      entityName={'BRAND'}
      service={'wrd'}
    />
  );
});
